import { Button } from "../../../ds2/components";
import "./AppChanges.css";

type AppChangesProps = {
    submitText?: string;
    saveDisabled?: boolean;
    onSubmit: () => void;
    onCancel: () => void;
}

export const AppChanges = ({submitText = "Submit", saveDisabled = false, onSubmit, onCancel} : AppChangesProps) => {

    // console.log("[AppChanges] saveDisabled: ", saveDisabled);
    
    return (
        <div className="app-changes">
            Changes have been made
            <Button
                variant="secondary"
                onClick={onCancel}>
                Cancel
            </Button>
            <Button
                variant="primary"
                onClick={onSubmit}
                disabled={saveDisabled}>
                {submitText}
            </Button>
            {/* <button 
                className="button-cancel"
                onClick={onCancel}
            >
                Cancel
            </button>
            <button 
                className="button-save"
                onClick={onSubmit}
                disabled={saveDisabled}
            >
                {submitText}
            </button> */}
            
        </div>
    )
}